export function base64ToByteArray(base64String) {
    // Decodifica la cadena base64 a un string binario
    let binaryString = atob(base64String);

    // Crea un array de bytes (Uint8Array) con la longitud del string binario
    let byteArray = new Uint8Array(binaryString.length);

    // Asigna cada valor del string binario al array de bytes
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }

    return Array.from(byteArray);
}

export function byteArrayToBase64(byteArray) {
    // Crea un string binario a partir del array de bytes
    let binaryString = "";
    for (let i = 0; i < byteArray.length; i++) {
        binaryString += String.fromCharCode(byteArray[i]);
    }

    // Convierte el string binario a base64
    let base64String = btoa(binaryString);

    return base64String;
}
